;(function () {
  function getDrawer(id) {
    return id ? document.getElementById(id) : null;
  }

  var BULLET_START = /^\s*[•·▪◦]\s*/;

  // SOURCE MODE 29.09: Zeilen aus dem DOM ableiten (Absaetze, <br>, Listenpunkte, eingetippte Bullets),
  // statt nur an echten Zeilenumbruechen im Text zu trennen - sonst kleben Details zusammen.
  function rawLines(content, splitInlineBullets) {
    var clone = content.cloneNode(true);
    clone.querySelectorAll('br').forEach(function (br) { br.replaceWith('\n'); });
    clone.querySelectorAll('li').forEach(function (node) {
      node.insertBefore(document.createTextNode('\n· '), node.firstChild);
    });
    clone.querySelectorAll('li, p, div, h1, h2, h3, h4, h5, h6, tr, dt, dd').forEach(function (node) {
      node.appendChild(document.createTextNode('\n'));
    });
    var text = clone.textContent || '';
    if (splitInlineBullets) text = text.replace(/\s+([•·▪◦])\s+/g, '\n$1 ');
    return text.split(/\n+/).map(function (l) { return l.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
  }

  function makeList() {
    var list = document.createElement('ul');
    list.className = 'source-details-list';
    return list;
  }

  function addItem(list, text) {
    var li = document.createElement('li');
    var span = document.createElement('span');
    span.textContent = text;
    li.appendChild(span);
    list.appendChild(li);
  }

  // Details: jede Zeile ist ein Punkt
  function normalizeDetails(content) {
    var lines = rawLines(content, true);
    if (!lines.length) return;
    var list = makeList();
    lines.forEach(function (line) { addItem(list, line.replace(/^\s*[•·▪◦\-–—]\s*/, '')); });
    content.innerHTML = '';
    content.appendChild(list);
  }

  // Beschreibung & Co: nur Zeilen, die mit einem Punkt beginnen, werden zur Liste
  // (Umbruch steht dann unter dem Wort darueber); normaler Text bleibt Absatz.
  function normalizeBullets(content) {
    var lines = rawLines(content, true);
    var hasBullets = lines.some(function (l) { return BULLET_START.test(l); });
    if (!hasBullets) return;
    var frag = document.createDocumentFragment();
    var list = null;
    lines.forEach(function (line) {
      if (BULLET_START.test(line)) {
        if (!list) { list = makeList(); frag.appendChild(list); }
        addItem(list, line.replace(BULLET_START, ''));
      } else {
        list = null;
        var p = document.createElement('p');
        p.textContent = line;
        frag.appendChild(p);
      }
    });
    content.innerHTML = '';
    content.appendChild(frag);
  }

  function normalizeDrawer(drawer) {
    if (!drawer || drawer.dataset.detailsNormalized === 'true') return;
    drawer.querySelectorAll('.source-product-drawer__content').forEach(function (content) {
      if (content.classList.contains('source-product-drawer__content--details')) normalizeDetails(content);
      else normalizeBullets(content);
    });
    drawer.dataset.detailsNormalized = 'true';
  }

  function openDrawer(trigger) {
    var drawer = getDrawer(trigger.getAttribute('data-source-drawer-open'));
    if (!drawer) return;

    normalizeDrawer(drawer);

    drawer.hidden = false;
    drawer._sourceTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var panel = drawer.querySelector('.source-product-drawer__panel');
        if (panel) panel.focus({ preventScroll: true });
      });
    });

    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    drawer.classList.remove('is-open');

    if (drawer._sourceTrigger) {
      drawer._sourceTrigger.setAttribute('aria-expanded', 'false');
      drawer._sourceTrigger.focus({ preventScroll: true });
    }

    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 400);

    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-source-drawer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(openTrigger);
      return;
    }

    var closeTrigger = event.target.closest('[data-source-drawer-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer(closeTrigger.closest('[data-source-product-drawer]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var drawer = document.querySelector('[data-source-product-drawer].is-open');
    if (drawer) closeDrawer(drawer);
  });
})();
